export default "__VITE_ASSET__b2pw8zRs__"